export default __webpack_public_path__ + "67635a5e3ab74e768ef3a876af47edbc.svg";